import React from 'react';

import { cdnImage } from '@/utils/image-utils';

export function LineChatIcon() {
  return (
    <img
      alt="LINE Chat icon"
      src={cdnImage('line-app.png', {
        width: '26',
        height: '26',
        fit: 'contain',
      })}
      className="object-cover"
    />
  );
}
